import { Injectable, inject } from "@angular/core";
import { ITranslateObject, JobsBillingCard } from "../views-interfaces";
import { MultiSelectModel, Option } from "@app/filter-menu/filter-types";
import { JobsAndBillingPriorityService, JobPriority } from "@app/shared/jobs-and-billing-priority";

@Injectable()
export class PriorityFilterGeneratorService {
    private readonly jobsAndBillingPriorityService = inject(JobsAndBillingPriorityService);

    generateModel(selection: Option[]) {
        const allOptions: Option[] = this.jobsAndBillingPriorityService.jobPriorityOptions.map((option) => {
            return {
                text: option.label,
                value: option.value,
            } as Option;
        });

        return {
            label: "JobsAndBilling.Priorities.Priority",
            allOptions,
            applicableOptions: allOptions,
            selection: selection.filter((selected) => allOptions.some((applicable) => applicable.value === selected.value)),
        } as MultiSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOptions: Option[],
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        if (!selectedOptions || selectedOptions.length === 0) {
            return null;
        } else {
            return {
                label,
                values: selectedOptions.map((value) => {
                    return value.text;
                }),
            };
        }
    }

    generateFilter(selectedValues: JobPriority[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            return (card: JobsBillingCard) => {
                return selectedValues.includes(card.job.priority as JobPriority);
            };
        }
    }
}
